import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AjaxResponse } from 'rxjs/ajax';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseRequester } from '../common/base-requester';

// Client for the returns Lambda (lnwshop-insight-functions/functions/returns,
// POST /internal/returns): the return index the scheduled collector keeps,
// and the shop's own marks — received and inspected — one MongoDB document
// per mark in their own collections (management-console.return_*).
// Follows the finance-tx shape: POST {operation, parameter}, unwrap
// `errorMessage`.

@Injectable({
    providedIn: 'root',
})
export class ReturnsApiService extends BaseRequester {
    request<T>(operation: string, parameter: object = {}): Observable<T> {
        return this.internalPostRequest(environment.returnsEndpoint, {
            operation,
            parameter,
        }).pipe(
            map((response: AjaxResponse) => {
                if (response.response?.errorMessage) {
                    throw new Error(response.response.errorMessage);
                }
                return response.response as T;
            }),
        );
    }
}
